// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2XNZH","inner":"Footer_inner__2NFec","nextIcon":"Footer_nextIcon__2O4cc","innerLeft":"Footer_innerLeft__2Smz7"};